// Status badge for a rental reservation (Yeati-Loc booking) in the usage-history drawer.
// Mirrors the labels and tones of the Yeati-Loc reservations list (admin) so a beneficiary
// sees the same wording: pending_approval → "En attente", confirmed → "Confirmée", etc. Kept
// local to the subventions feature (no cross-feature import); keep in sync with the booking
// AASM states. Statuses that drop their subsidy debit (cancelled / rejected) do not reach the
// drawer, but are mapped for completeness.

export type ReservationStatusBadge = { label: string, classes: string };

export const RESERVATION_STATUS_BADGE: Record<string, ReservationStatusBadge> = {
  open: { label: "Panier", classes: "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300" },
  pending_checkout: { label: "Paiement en cours", classes: "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300" },
  pending_approval: { label: "En attente", classes: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300" },
  approved: { label: "Validée - à régler", classes: "bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300" },
  confirmed: { label: "Confirmée", classes: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300" },
  in_progress: { label: "En cours", classes: "bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300" },
  return_pending: { label: "Retour attendu", classes: "bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300" },
  pending_return: { label: "Retour attendu", classes: "bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300" },
  return_completed: { label: "Terminée", classes: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300" },
  completed: { label: "Terminée", classes: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300" },
  rejected: { label: "Refusée", classes: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300" },
  cancelled: { label: "Annulée", classes: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300" },
};

export const reservationStatusBadge = (
  status: string | null | undefined,
): ReservationStatusBadge | undefined => (status ? RESERVATION_STATUS_BADGE[status] : undefined);
